import React, { Component, Fragment } from 'react'
import ROCKET_IMG from 'images/rocket.svg'
import SuccessLander from 'components/SuccessLander'
import OnboardingWidgetTip, { TipTextType }  from 'components/OnboardingWidgetTip'

const HEADER_TEXT = 'Welcome to Drift!'
const BUTTON_TEXT = 'Get Started'
const SUBHEADER_TEXT = 'We want your onboarding experience to align with your goals and set you up for success! Just answer a few questions to get started.'

class DealLinkSuccessStep extends Component {

  componentDidMount() {
    const { actions, defaultDirectoryUrl } = this.props
    actions.checkUniqueHandle(defaultDirectoryUrl)
  }

  render() {
    const { onContinue } = this.props

    return (
      <Fragment>
        <SuccessLander
        image={ROCKET_IMG}
        headerText={HEADER_TEXT}
        buttonText={BUTTON_TEXT}
        onButtonClick={onContinue}
        className="deal-link-success-lander"
        subheaderText={SUBHEADER_TEXT}
        />
        <OnboardingWidgetTip tipTextKey={TipTextType.INTRO} />
      </Fragment>
    )
  }
}

export default DealLinkSuccessStep


// WEBPACK FOOTER //
// ./src/layouts/DealLinkSuccessStep/index.js